<template>
  <div class="calico-navbar">
    <div class="container">
      <div class="branding">
        <i
          class="bi bi-list"
          @click="$emit('menu')"
        />
        <a href="/">
          <img
            src="@/assets/logos/beta-logo.svg"
            height="17px"
          >
        </a>
      </div>
      <div
        v-if="userRole === 'Representative'"
        style="width: fit-content;"
      >
        <button
          class="button-tertiary-icon"
          @click="$emit('search')"
        >
          <i class="bi bi-search black-fill icon--small" />
        </button>
      </div>
      <div style="width: fit-content;">
        <button
          class="button-tertiary-icon"
          @click="$emit('settings')"
        >
          <i class="bi bi-gear-wide black-fill icon--small" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import service from "@/services";

export default {
  name: "CalicoNavbar",
  data() {
    return {
      userRole: null,
    };
  },
  async created() {
    const user = await service.user.get();
    this.userRole = user?.role?.name;
  }
};
</script>

<style lang="scss">
.calico-navbar {
  display: flex;
  width: 100%;
  justify-content: center;
  background: $color-background-primary;
  .container {
    @include inline-space($space-medium);
    width: 100%;
    max-width: $large-screen-max-width;
    padding: $space-small $space-large;
    align-items: center;

    .branding {
      @include inline-space($space-xsmall);
      align-items: center;
      flex: 1
    }
    
    .bi-list {
      @include inline-space-mobile-only($space-none);
      font-size: $icon-medium;
    }

    .bi-gear-wide{
      color: $color-black;
    }

    @media (max-width: $mobile-breakpoint-max-width) {
      padding: $space-small $space-medium;
    }
  }
}
</style>
